// ترتیبِ این دو import مهم است: boot باید اول باشد تا initCore قبل از هر
// چیزی که از core می‌آید صدا زده شده باشد. نگاه کن به بالای src/boot.ts.
import './boot';
import './ui/base.css';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import { installTableCollapse } from './ui/collapseTables';

const el = document.getElementById('root');
if (!el) throw new Error('#root نیست — index.html دست‌کاری شده؟');
installTableCollapse(el);

createRoot(el).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
